export default {
    upgrade: {
        title: 'Choose the Right Plan for You',
        subtitle: 'Unlock professional features and boost your productivity.',
        pickYourPlan: 'Pick your plan',
        subscribeSuccess: 'Subscription successful',
        contactSales: 'Please contact our sales team for enterprise solutions.',
        enterpriseRestriction: 'Paid subscriptions are currently available for individual users only. Enterprise users, please contact our sales team for a tailored solution.',
        freeplanActivated: 'Basic plan is already active',
        planNotFound: 'Selected plan not found',
        alreadySubscribed: 'You are already subscribed to this plan',
        priceIdNotConfigured: 'Payment configuration not available for this plan',
        paymentInitFailed: 'Failed to initialize payment. Please try again.',
        plans: {
            period: {
                monthly: ' / month',
                yearly: ' / year',
            },
            basic: {
                name: 'Basic',
                subtitle: 'Essential features for getting started',
                price: 'Free',
                description: 'Experience AI Agents for end-to-end patent search and drafting.',
                button: 'Current Plan',
                featuresHeader: 'Plan Features:',
            },
            pro: {
                name: 'Pro',
                subtitle: 'Advanced tools for professionals',
                description: 'Accelerated drafting a prosecution workflow',
                button: 'Subscribe to Pro',
                moduleName: 'Pro Monthly / Yearly',
                yearlySavings: 'Save with annual billing',
                featuresHeader: 'Multiple drafting features to assist with global patent applications:',
                features: {
                    additionalHiroMessages: 'Additional Hiro messages',
                    fullDocumentExports: 'Full document exports',
                    disclosure1Doc: 'Invention Disclosure ({n} Doc)',
                    application1Doc: 'Patent Application ({n} Doc)',
                    oar1Doc: 'Office Action Response ({n} Doc)',
                },
            },
            enterprise: {
                name: 'Enterprise',
                subtitle: 'Organization-wide intelligence',
                price: 'Contact Us',
                description: 'Comprehensive IP protection for organizations',
                button: 'Book a Demo',
                featuresHeader: 'Everything in Drafting pro, plus',
                features: {
                    securityHeader: 'Security & Control',
                },
                benefits: {
                    expandedSearch: 'Expanded search volume',
                    humanInLoop: 'Human-in-the-loop',
                    advancedEditor: 'Advanced inline editor',
                    workspaceIntegration: 'Workspace integration',
                    professionalExport: 'Professional document export',
                    evenMoreHiro: 'Even more Hiro Copilot messages',
                    ssoSecurity: 'SSO & advanced security',
                    dedicatedSuccess: 'Dedicated customer success manager',
                },
            },
            api: {
                name: 'API',
                subtitle: 'Developer-first integration',
                price: 'Custom',
                description: 'Seamless IP intelligence integration',
                button: 'Learn More',
                featuresHeader: 'Includes Pro, plus:',
                features: {
                    unifiedAiDataLoop: 'Unified AI-data loop for actionable insights',
                    instantIntegration: 'Instant integration via modular widgets and SDKs',
                    predictableScaling: 'Predictable scaling with transparent usage models',
                    infrastructure: 'Enterprise-grade infrastructure with 99.9% SLA',
                    connectivity: 'Universal connectivity across leading tech stacks',
                    support: 'Proactive support and health monitoring',
                },
            },
            features: {
                hiroMessages: 'Hiro Copilot messages',
                disclosure: 'Invention Disclosure',
                application: 'Patent Application',
                oar: 'Office Action Response',
                templateInstructionStyle: 'Template/Instruction/Style',
                wordWpsPlugin: 'Word Plugin (Coming soon)',
            },
        },
        billingCycle: {
            monthly: 'Monthly',
            yearly: 'Yearly',
            saveAmount: 'Save $ {amount}',
        },
        features: 'Features',
        benefits: 'Benefits',
        recommend: 'Recommend',
        comparison: {
            title: 'Compare Plans',
            plans: {
                guest: 'Guest',
                free: 'Basic',
                pro: 'Pro',
                enterprise: 'Enterprise',
            },
            categories: {
                agent: 'Core Agent',
                features: 'Other Function',
                ai: 'AI Tool',
                security: 'Security & Control',
                collaboration: 'Enterprise Collaboration',
            },
            rows: {
                disclosure: 'Invention Disclosure',
                application: 'Patent Application',
                oar: 'Office Action Response',
                templates: 'Template',
                instructions: 'Instruction',
                styles: 'Style',
                draftingCenter: 'Drafting Center',
                officePlugin: 'Word Plugin (Coming soon)',
                aiChat: 'Hiro',
                chatLimitN: '{n} times/day',
                chatLimit500: '500 times/day',
                moreUsage: 'More limits',
                evenMoreUsage: 'Custom limits',
                createProject: 'Create Projects',
                exportProject: 'Export Projects',
                sharedAssets: 'Template/Instruction/Style Share',
                enterpriseManagement: 'Enterprise Management',
            },
        },
    },
    pricing: {
        payment: {
            creatingSession: 'Creating payment session...',
            errors: {
                createSessionFailed: 'Failed to create payment session. Please check your current account type.',
                verifyFailed: 'Failed to verify payment status',
                verificationFailed: 'Payment verification failed',
                verificationError: 'An error occurred during verification',
                invalidCallback: 'Invalid payment callback',
                noPriceId: 'Price information not configured',
            },
        },
    },
};
